import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import type { FileForProcessing } from '../../../../../Model/index.js'
import { qualityFilterLossWarning } from '../../../../../Model/Order/qualityFilterLoss.ts'

interface QualityFilterLossWarningProps {
  items: readonly FileForProcessing[]
  excludedItems?: readonly string[]
}

/** Warns before postprocessing when quality filtering left almost nothing; nothing otherwise. */
export const QualityFilterLossWarning = ({ items, excludedItems = [] }: QualityFilterLossWarningProps) => {
  const excluded = new Set(excludedItems)
  const warning = qualityFilterLossWarning(items.filter((i) => !excluded.has(i.id)))
  if (!warning) {
    return null
  }
  return (
    <div role="alert" className="alert alert-warning my-3 flex items-start gap-2 text-sm" data-testid="quality-filter-loss-warning">
      <ExclamationTriangleIcon className="w-5 h-5 shrink-0" />
      <span>{warning}</span>
    </div>
  )
}
